/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardCheckoutPaymentMethodDto
 */
export interface CardCheckoutPaymentMethodDto {
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    applePayToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedCardNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedExpiryMonth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedExpiryYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedSecurityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    holderName?: string | null;
}

/**
 * Check if a given object implements the CardCheckoutPaymentMethodDto interface.
 */
export function instanceOfCardCheckoutPaymentMethodDto(value: object): value is CardCheckoutPaymentMethodDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CardCheckoutPaymentMethodDtoFromJSON(json: any): CardCheckoutPaymentMethodDto {
    return CardCheckoutPaymentMethodDtoFromJSONTyped(json, false);
}

export function CardCheckoutPaymentMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardCheckoutPaymentMethodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'applePayToken': json['applePayToken'] === undefined ? undefined : json['applePayToken'] === null ? null : json['applePayToken'],
        'encryptedCardNumber': json['encryptedCardNumber'] === undefined ? undefined : json['encryptedCardNumber'] === null ? null : json['encryptedCardNumber'],
        'encryptedExpiryMonth': json['encryptedExpiryMonth'] === undefined ? undefined : json['encryptedExpiryMonth'] === null ? null : json['encryptedExpiryMonth'],
        'encryptedExpiryYear': json['encryptedExpiryYear'] === undefined ? undefined : json['encryptedExpiryYear'] === null ? null : json['encryptedExpiryYear'],
        'encryptedSecurityCode': json['encryptedSecurityCode'] === undefined ? undefined : json['encryptedSecurityCode'] === null ? null : json['encryptedSecurityCode'],
        'holderName': json['holderName'] === undefined ? undefined : json['holderName'] === null ? null : json['holderName'],
    };
}

export function CardCheckoutPaymentMethodDtoToJSON(json: any): CardCheckoutPaymentMethodDto {
    return CardCheckoutPaymentMethodDtoToJSONTyped(json, false);
}

export function CardCheckoutPaymentMethodDtoToJSONTyped(value?: CardCheckoutPaymentMethodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'applePayToken': value['applePayToken'],
        'encryptedCardNumber': value['encryptedCardNumber'],
        'encryptedExpiryMonth': value['encryptedExpiryMonth'],
        'encryptedExpiryYear': value['encryptedExpiryYear'],
        'encryptedSecurityCode': value['encryptedSecurityCode'],
        'holderName': value['holderName'],
    };
}

